@use 'utils';

$colors: (
  /* dark blue */ dark-blue-600: #031732,
  dark-blue-500: #082042,
  dark-blue-400: #384e68,
  dark-blue-300: #6a7a8e,
  dark-blue-200: #9ca6b4,
  dark-blue-100: #ced2d9,

  /* light blue */ light-blue-600: #5a779a,
  light-blue-500: #7390b0,
  light-blue-400: #8ea7c0,
  light-blue-300: #aabdd0,
  light-blue-200: #c7d3e0,
  light-blue-100: #e3e9ef,

  /* grey */ grey-600: #2b2b2b,
  grey-500: #626262,
  grey-400: #808080,
  grey-300: #aaa,
  grey-200: #d5d5d5,
  grey-100: #f5f5f5,
  grey-50: #fafafa,

  /* green */ green-600: #253924,
  green-500: #364f35,
  green-400: #5f715d,
  green-300: #869586,
  green-200: #afb9ae,
  green-100: #d7dcd7,

  /* orange */ orange-600: #db8a21,
  orange-500: #e49b3d,
  orange-400: #eaad61,
  orange-300: #efc289,
  orange-200: #f5d6b1,
  orange-100: #f9ead8,

  /* beige */ beige-600: #a8a18f,
  beige-500: #bfb7a6,
  beige-400: #cec7b7,
  beige-300: #ddd7c9,
  beige-200: #eae7df,
  beige-100: #f6f5f1,

  /* rust */ rust-600: #ab3d06,
  rust-500: #be530a,
  rust-400: #cc7438,
  rust-300: #d8976a,
  rust-200: #e6b99c,
  rust-100: #f3ddce,

  /* admin colors */ admin-warning: #ffc149,
  admin-info: #4d9aff,
  admin-success: #5eb273,
  admin-error: #cd5437,

  /* white */ white-100: #fff,
);

:export {
  @each $key, $value in $colors {
    #{utils.camel-case($key)}: #{$value};
  }
}

$hw-white: #fff;
$hw-black-1: #2b2b2b;

$hw-blue-1: #082042;
$hw-blue-2: #7390b0;
$hw-blue-3: #6a7a8e;
$hw-blue-4: #2699fb;
$hw-blue-5: #e3e9ef;
$hw-blue-6: #384e68;

$hw-gray-1: #f5f5f5;
$hw-gray-2: #ddd7c9;
$hw-gray-3: #eae7df;
$hw-gray-4: #e5e5e5;
$hw-gray-5: #aaa;

$hw-green-1: #364f35;
$hw-green-2: #869586;
$hw-green-3: #80cb36;

$hw-orange-1: #e49b3c;
$hw-orange-2: #bf530a;
$hw-orange-3: #eaad61;
$hw-orange-4: #cc7438;
$hw-orange-5: #f9ead8;

$hw-error-red: #cd5437;

.white {
  color: $hw-white;
}

.gray-5 {
  color: $hw-gray-5;
}

.blue-1 {
  color: $hw-blue-1;
}

.orange-1 {
  color: $hw-orange-1;
}

.error-red {
  color: $hw-error-red;
}

.bg-white {
  background-color: var(--white-100);
}

.bg-blue-1 {
  background-color: $hw-blue-1;
}

.bg-blue-2 {
  background-color: $hw-blue-2;
}
